import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../../assets';
import videoApp from '../../assets/videos/video_app.mp4';

const AppLandingPage = () => {
  return (
    <>
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Readex+Pro:wght@300;400;500;600;700&display=swap');
          .landing-body {
            font-family: 'Readex Pro', system-ui, -apple-system, sans-serif;
            background-color: #000;
            color: #fff;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            height: 100vh;
            margin: 0;
            padding: 0;
          }
          .hero-title {
            letter-spacing: -0.04em;
            line-height: 0.95;
          }
        `}
      </style>
      <div className="landing-body">
        <section className="relative h-screen w-full overflow-hidden bg-black">
          {/* Background video */}
          <video
            className="absolute inset-0 w-full h-full object-cover"
            autoPlay
            loop
            muted
            playsInline
            src={videoApp}
            style={{ transform: 'scale(0.9)', objectPosition: '50% 25%' }} // <-- Lo reduje a 0.9 y lo enfoqué hacia la cabeza (25%)
          />

          {/* Navbar */}
          <nav className="absolute z-20 px-4 md:px-10 pt-4 md:pt-6 top-0 left-0 right-0 flex flex-wrap items-center justify-between gap-y-4 gap-x-2">
            {/* Left pill */}
            <div className="order-1 flex items-center gap-2 md:gap-4 bg-neutral-900/90 backdrop-blur rounded-full px-3 py-2 md:pl-6 md:pr-8 md:py-4 border-2 border-gray-500">
              <Link to="/">
                <img src={images.logo_gym} alt="Logo" className="h-5 md:h-10 w-auto hover:scale-110 transition-transform cursor-pointer" />
              </Link>
              <span className="text-white text-xs md:text-lg font-medium tracking-tight">Energy Huánuco</span>
            </div>

            {/* Right button */}
            <a
              href="https://maps.app.goo.gl/3kVH4nAgpWf4LsNLA"
              target="_blank"
              rel="noopener noreferrer"
              className="order-2 md:order-3 bg-neutral-900/90 text-white text-xs md:text-sm font-medium rounded-full px-4 py-2 md:px-6 md:py-3 hover:bg-neutral-800 transition-colors pointer-events-auto inline-flex items-center gap-2 border-2 border-gray-500 backdrop-blur"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 md:h-5 md:w-5 text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.243-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              Ubicación
            </a>

            {/* Center pill */}
            <div className="order-3 md:order-2 flex flex-wrap justify-center items-center gap-1 md:gap-1 bg-neutral-900/90 backdrop-blur rounded-2xl md:rounded-full px-2 py-2 md:px-3 w-full md:w-auto mt-[-1%] md:mt-0 border-2 border-gray-500">
              <Link to="/" className="text-neutral-300 hover:text-white transition-colors text-xs md:text-sm px-3 md:px-5 py-1 md:py-2 rounded-full">Sitio Web</Link>
              <a href="https://www.tiktok.com/@energyhco" target="_blank" rel="noreferrer" className="text-neutral-300 hover:text-white transition-colors text-xs md:text-sm px-3 md:px-5 py-1 md:py-2 rounded-full">Tik Tok</a>
              <a href="https://www.facebook.com/energy.huanuco" target="_blank" rel="noreferrer" className="text-neutral-300 hover:text-white transition-colors text-xs md:text-sm px-3 md:px-5 py-1 md:py-2 rounded-full">Facebook</a>
              <a href="https://www.instagram.com/energyhuanuco/" target="_blank" rel="noreferrer" className="text-neutral-300 hover:text-white transition-colors text-xs md:text-sm px-3 md:px-5 py-1 md:py-2 rounded-full">Instagram</a>
            </div>
          </nav>

          {/* Foreground content wrapper */}
          <div className="relative h-full w-full pointer-events-none">
            {/* Three giant staggered headline words */}
            <h1 className="hero-title absolute text-white font-medium text-[10vw] md:text-[9vw] left-4 md:left-10 top-[18%]">
              Alcanza
            </h1>
            <h1 className="hero-title absolute text-white font-medium text-[10vw] md:text-[9vw] right-4 md:right-10 top-[38%]">
              tus
            </h1>
            <h1 className="hero-title absolute text-white font-medium text-[10vw] md:text-[9vw] left-[18%] md:left-[28%] top-[58%]">
              metas
            </h1>

            {/* Description paragraph */}
            <p className="absolute left-6 md:left-10 top-[46%] max-w-[240px] text-[15px] leading-snug text-white/90">
              Guarda tus progresos y empoderate con un seguimiento personalizado.
            </p>

            {/* Stat block - top-right */}
            <div className="absolute right-6 md:right-24 top-[14%] md:top-[14%]">
              <div className="flex items-center gap-3 justify-end">
                <div className="hidden md:block h-px w-24 bg-white/40 rotate-[20deg]"></div>
                <span className="text-4xl md:text-5xl font-medium tracking-tight">+2.5k</span>
              </div>
              <p className="text-xs md:text-sm text-white/70 mt-1 text-right">Siguen a Energy Huánuco</p>
            </div>

            {/* Stat block - bottom-left */}
            <div className="absolute left-6 md:left-20 bottom-32 md:bottom-36">
              <div className="flex items-center gap-3">
                <span className="text-4xl md:text-5xl font-medium tracking-tight">+110</span>
                <div className="hidden md:block h-px w-24 bg-white/40 rotate-[-20deg]"></div>
              </div>
              <p className="text-xs md:text-sm text-white/70 mt-1">Ejercicios disponibles</p>
            </div>

            {/* Stat block - bottom-right */}
            <div className="absolute right-6 md:right-20 bottom-28 md:bottom-32">
              <div className="flex items-center gap-3 justify-end">
                <div className="hidden md:block h-px w-24 bg-white/40 rotate-[-20deg]"></div>
                <span className="text-4xl md:text-5xl font-medium tracking-tight">+50</span>
              </div>
              <p className="text-xs md:text-sm text-white/70 mt-1 text-right">usuarios</p>
            </div>

            {/* Bottom gradient overlay */}
            <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-b from-transparent to-black"></div>

            {/* Call to action & Legal text */}
            <div className="absolute bottom-6 md:bottom-8 left-0 right-0 z-30 flex flex-col items-center justify-center pointer-events-auto space-y-5">
              <a
                href="https://appenergyhco.web.app/login"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-orange-500 text-white text-lg md:text-2xl font-bold rounded-full px-10 py-3 md:px-14 md:py-4 hover:bg-orange-600 transition-all shadow-[0_0_20px_rgba(249,115,22,0.4)] hover:shadow-[0_0_30px_rgba(249,115,22,0.6)] hover:scale-105 inline-block text-center"
              >
                Únete ahora
              </a>

              <div className="flex flex-col items-center justify-center text-[10px] md:text-xs text-white/40 space-y-1">
                <div className="flex gap-3 md:gap-4 flex-wrap justify-center">
                  <Link to="/terminos-y-condiciones" className="hover:text-white/80 transition-colors">términos y condiciones</Link>
                  <span>|</span>
                  <Link to="/politica-de-privacidad" className="hover:text-white/80 transition-colors">política de privacidad</Link>
                  <span>|</span>
                  <a href="https://maps.app.goo.gl/3kVH4nAgpWf4LsNLA" target="_blank" rel="noopener noreferrer" className="hover:text-white/80 transition-colors">ubicación</a>
                </div>
                <p>creado por <a href="https://github.com/sebastianTG7" target="_blank" rel="noopener noreferrer">XtremeTG7</a> • Energy huanuco app v1.0</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AppLandingPage;
